import React from "react";
import { useSiteContext } from "../../context/SiteContext";
import { VerticalTemplates } from "../../services/Templates";

import { usePubSub } from "../../config/sdkConfig";

import { useMeetingAppContext } from "../../MeetingAppContextDef";

export function PrompterPanel({ panelHeight }) {
    const {
        meetingRole,
        prompterElement,
        setPrompterElement,
    } = useSiteContext();
    const { setSideBarMode } = useMeetingAppContext();
    const { publish: publishCloseElementSection } = usePubSub(
        "CLOSE_ELEMENT_SECTION"
    );

    const settings = prompterElement?.settings
        ? typeof prompterElement.settings === "string"
            ? JSON.parse(prompterElement.settings)
            : prompterElement.settings
        : {};

    // Get theme from settings, default to "light"
    const theme = settings.theme || "light";

    const PrompterComponent = VerticalTemplates["prompter"]?.preview;

    if (!PrompterComponent || !prompterElement) {
        return (
            <div
                className="flex items-center justify-center text-white bg-gray-800"
                style={{ height: panelHeight }}
            >
                <p>No prompter available</p>
            </div>
        );
    }

    return (
        <div
            className="w-full bg-gray-800 overflow-hidden"
            style={{ height: panelHeight }}
        >
            <PrompterComponent
                {...settings}
                theme={theme}
                inmeeting={true}
                position="center"
                onClose={() => {
                    setPrompterElement(null);
                    setSideBarMode(null);
                    if (meetingRole === "moderator" || meetingRole === "co-host") {
                        publishCloseElementSection(JSON.stringify({
                            set: true,
                        }));
                    }
                }}
            />
        </div>
    );
}

